import { Link } from "react-router-dom";
import "./Button2.css";

// Define the props that the Input component will accept
interface InputProps {
  href?: string;
  name: string;
  text: string;
  type?: string;
  classname?: string;
  disabled?: boolean;
  onClick?: () => void;
}

const Button2: React.FC<InputProps> = ({
  href,
  name,
  text,
  type,
  classname,
  disabled = false,
  onClick,
}) => {
  return href ? (
    // <Link href={href} id={name} to={href} className={name} type={type}>
    <Link to={href} id={name} className={classname} type={type}>
      <button
        id={name}
        className={classname}
        onClick={onClick}
        disabled={disabled}
      >
        {text}
      </button>
    </Link>
  ) : (
    // </Link>
    <button
      id={name}
      className={classname}
      onClick={onClick}
      disabled={disabled}
    >
      {text}
    </button>
  );
};

export default Button2;
